/* istanbul ignore file */

export * from './mockUseContentfulContentTypeEntry';
export * from './useContentfulContentTypeEntry';
